import React, { useState, useContext, useEffect } from 'react'
import './Forgot.css'
import logo from '../asset/image/forgot.png'
import { Form, Button } from 'react-bootstrap'
import { forgotPassword } from '../Network/Authentication'
import { Loading } from '../Library'
import { LanguageContext } from '../Language/LanguageContext'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { setDocumentTitle } from '../AppTitle'

function Forgot() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.forgot
    const history = useHistory()
    const [isFinish, setFinish] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [email, setEmail] = useState("")
    const [error, setError] = useState("")

    const onSubmit = () =>{
        setLoading(true);
        forgotPassword(email,
            (response)=>{
                setLoading(false);
                setFinish(true)
            },
            (error)=>{
                setLoading(false);
                if(error.response !== undefined){
                    setError(error.response.data.message)
                }else{
                    setError(error.message)
                }
                
            })
    }

    useEffect(()=>{
        setDocumentTitle("Forgot")
    },[])

    return (
        <>
        { isLoading ? <Loading title="Sending an E-mail"/> : null }
        <div id="forgot">
            <div>
                <div id="container">
                    { !isFinish ?
                    <>
                    <div className="logo-container">
                        <img src={logo} className="logo" alt="Logo"/>
                    </div>
                    
                    <div className="title">
                        <b>{lang.forgot}</b>
                    </div>
                    <div className="desc">
                        {lang.enter}
                    </div>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault()
                        onSubmit()
                    }}
                    >
                        <Form.Control
                        placeholder={lang.email}
                        className="input-form"
                        value={email}
                        onChange={(e)=>setEmail(e.target.value)}
                        required
                        />
                        { error !== "" ?
                        <div className="error-text">
                            {error}
                        </div>
                        : null
                        }
                        <Button type="submit" className="submit-button">
                            {lang.send}
                        </Button>
                    </Form>
                    </>
                    :
                    <div id="finish-forgot">
                        <FontAwesomeIcon icon={faCheckCircle} className="icon"/>
                        <div className="title">{lang.sent}</div>
                        <div className="desc">
                            {lang.check_email} <b>{email}</b> {lang.check_email2}
                        </div>
                        <Button 
                        className="submit-button"
                        onClick={()=>history.push("/login")}>
                            {lang.go_back}
                        </Button>
                    </div>
                    }
                </div>
            </div>
            
        </div>
        </>
    )
}

export default Forgot
